import {
  Component,
  Input,
  OnDestroy,
  ViewEncapsulation,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import {
  getTankGauges,
  getTankGaugeTypes,
} from "src/app/store/actions/tank-gauges/tank-gauges.actions";
import { getSiteWarehouseList } from "src/app/store/actions/sites/sites.actions";
import {
  AppState,
  siteWarehousesLoadedState,
  tankGaugeListState,
  tankGaugeTypesState,
} from "src/app/store/reducers";

import { WarehouseDTO } from "src/app/models/site-devices/warehouseDTO";
import {
  TankGaugeType,
  TankLevelGaugesDTO,
} from "src/app/models/tank-gauges/tank-gaugesDTO";
import { SiteWarehouseDTO } from "src/app/models/Sites/siteWarehouseDTO";


import { TankGaugeFormDialogComponent } from "./dialog/tank-gauge-form-dialog.component";

@Component({
  selector: "site-tank-gauges",
  templateUrl: "./tank-gauges.component.html",
  styleUrls: ["./tank-gauges.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TankGaugesComponent implements OnDestroy {
  _siteCode: string;

  @Input() set siteCode(code: string) {
    this._siteCode = code;
    if (this._siteCode) {
      this.loadWarehouses(this._siteCode);
      this.loadTankGauges(this._siteCode);
      this.loadTankGaugeTypes();
    }
  }

  @Input() permissionResource: string;

  tankGaugeList$: Observable<TankLevelGaugesDTO[]>;
  tankGaugeList: TankLevelGaugesDTO[];
  tankGaugeSub: Subscription;
  currentTankGauge: TankLevelGaugesDTO;

  warehouseList$: Observable<WarehouseDTO[]>;
  warehouseList: WarehouseDTO[];
  warehouseSub: Subscription;

  tankGaugeTypesList$: Observable<TankGaugeType[]>;
  tankGaugeTypesList: TankGaugeType[];
  tankGaugeTypesSub: Subscription;

  isTankGaugeSelected: boolean = false;

  constructor(
    private store: Store<AppState>,
    public dialog: MatDialog
  ) {
    this.tankGaugeList$ = this.store.pipe(select(tankGaugeListState));
    this.warehouseList$ = this.store.pipe(select(siteWarehousesLoadedState));
    this.tankGaugeTypesList$ = this.store.pipe(select(tankGaugeTypesState));
  }

  loadTankGauges(siteCode: string) {
    this.tankGaugeSub = this.tankGaugeList$.subscribe(
      (tankGauges: TankLevelGaugesDTO[]) => {
        this.tankGaugeList = tankGauges;
        if (tankGauges && tankGauges.length && this.currentTankGauge) {
          const { code: currentProbeCode } = this.currentTankGauge;
          this.currentTankGauge = tankGauges.find(({ code }) => code === currentProbeCode);
        }
        this.resetTankGauge();
      }
    );
    this.store.dispatch(getTankGauges({ 
      code: siteCode,
      pageReq: { realSize: true, offset: 0, limit: 999 },
    }));
  }

  loadWarehouses(code: string) {
    this.warehouseSub = this.warehouseList$.subscribe(
      (warehouses: SiteWarehouseDTO[]) => {
        if (warehouses) {
          this.warehouseList = warehouses.filter(
            (warehouse) => warehouse.warehouseType?.code === "WET"
          );
        }
      }
    );
    this.store.dispatch(getSiteWarehouseList({ 
      code,
      pageReq: { realSize: true, offset: 0, limit: 999 },
    }));
  }

  loadTankGaugeTypes() {
    this.tankGaugeTypesSub = this.tankGaugeTypesList$.subscribe(
      (tankGaugeTypes: TankGaugeType[]) => {
        if (tankGaugeTypes) {
          this.tankGaugeTypesList = tankGaugeTypes;
        }
      }
    );
    this.store.dispatch(getTankGaugeTypes(null));
  }

  resetTankGauge() {
    this.dialog.closeAll();
    this.isTankGaugeSelected = false;
    this.currentTankGauge = null;
  }

  selectTankGauge(tankGauge: TankLevelGaugesDTO) {
    this.isTankGaugeSelected = true;
    this.currentTankGauge = tankGauge;

    this.openTankGaugeFormDialog(false);
  }

  create() {
    this.isTankGaugeSelected = false;
    this.currentTankGauge = null;

    this.openTankGaugeFormDialog(true);
  }

  openTankGaugeFormDialog(isCreate: boolean) {
    this.dialog.open(TankGaugeFormDialogComponent, {
      autoFocus: false,
      data: {
        isCreate,
        siteCode: this._siteCode,
        currentTankGauge: this.currentTankGauge,
        tankGaugeTypesList: this.tankGaugeTypesList,
        warehouseList: this.warehouseList,
      }
    });
  }

  ngOnDestroy(): void {
    if (this.tankGaugeSub) {
      this.tankGaugeSub.unsubscribe();
    }
    if (this.tankGaugeTypesSub) {
      this.tankGaugeTypesSub.unsubscribe();
    }
    if (this.warehouseSub) {
      this.warehouseSub.unsubscribe();
    }
  }
}
